import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import api from '../../services/apiService';
import './RegisterPlayer.scss';

const RegisterPlayer = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { teamId, teamName } = location.state || {};

    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        role: 'admin', // Default to admin for first registration
        position: 'MID',
        preferredFoot: 'right'
    });
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        // Redirect if no team ID is present
        if (!teamId) {
            navigate('/admin/register-team');
        }
    }, [teamId, navigate]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        setError(null);

        try {
            const response = await api.post(`${process.env.REACT_APP_API_URL}/register_player.php`, {
                ...formData,
                teamId
            });

            if (response.data.success) {
                // Navigate to team dashboard or success page
                navigate('/admin/teams');
            } else {
                setError(response.data.message || 'Failed to register player/admin');
            }
        } catch (err) {
            setError(err.message || 'An error occurred while registering the player/admin');
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="register-player-container">
            <h2>Register Team Admin</h2>
            <p className="team-info">Team: {teamName}</p>

            {error && (
                <div className="error-message">
                    {error}
                </div>
            )}

            <form onSubmit={handleSubmit} className="register-player-form">
                <div className="form-group">
                    <label htmlFor="firstName">First Name *</label>
                    <input
                        type="text"
                        id="firstName"
                        name="firstName"
                        value={formData.firstName}
                        onChange={handleChange}
                        required
                        placeholder="Enter first name"
                    />
                </div>

                <div className="form-group">
                    <label htmlFor="lastName">Last Name *</label>
                    <input
                        type="text"
                        id="lastName"
                        name="lastName"
                        value={formData.lastName}
                        onChange={handleChange}
                        required
                        placeholder="Enter last name"
                    />
                </div>

                <div className="form-group">
                    <label htmlFor="email">Email *</label>
                    <input
                        type="email"
                        id="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        required
                        placeholder="Enter email address"
                    />
                </div>

                <div className="form-group">
                    <label htmlFor="phone">Phone Number *</label>
                    <input
                        type="tel"
                        id="phone"
                        name="phone"
                        value={formData.phone}
                        onChange={handleChange}
                        required
                        placeholder="+44 7123 456789 or 07123 456789"
                        maxLength="20"
                    />
                </div>

                <div className="form-group">
                    <label htmlFor="position">Position *</label>
                    <select
                        id="position"
                        name="position"
                        value={formData.position}
                        onChange={handleChange}
                        required
                    >
                        <option value="GK">Goalkeeper</option>
                        <option value="DEF">Defender</option>
                        <option value="MID">Midfielder</option>
                        <option value="FWD">Forward</option>
                    </select>
                </div>

                <div className="form-group">
                    <label htmlFor="preferredFoot">Preferred Foot *</label>
                    <select
                        id="preferredFoot"
                        name="preferredFoot"
                        value={formData.preferredFoot}
                        onChange={handleChange}
                        required
                    >
                        <option value="right">Right</option>
                        <option value="left">Left</option>
                        <option value="both">Both</option>
                    </select>
                </div>

                <button 
                    type="submit" 
                    className="submit-button"
                    disabled={isSubmitting}
                >
                    {isSubmitting ? 'Registering...' : 'Register Admin'}
                </button>
            </form>
        </div>
    );
};

export default RegisterPlayer; 